<template>
  <v-tabs fixed centered>
    <v-tabs-bar :class="{ 'grey darken-3':!light, 'white':light }" dark>
      <v-tabs-slider class="blue"></v-tabs-slider>
      <v-tabs-item
        :href="'#tab-' + 1"
      
      >
        <span   :class="{ 'white--text':!light, 'black--text':light }">Overview</span> 
      </v-tabs-item>
            <v-tabs-item
        :href="'#tab-' + 2"
       
      >
       <span   :class="{ 'white--text':!light, 'black--text':light }"> Location</span>
      </v-tabs-item>
    </v-tabs-bar>
    <v-tabs-items  :touchless="true" :cycle="false">
      <v-tabs-content
        :id="'tab-' + 1"
        :lazy='true'
      >
        <v-card style="background-color:white" flat>
          <v-card-text class="pr-0 pl-0">
            <slot></slot>
          </v-card-text>
        </v-card>
      </v-tabs-content>
      <v-tabs-content
        :id="'tab-' + 2"
         :lazy='true'
      >
        <v-card flat>
          <v-card-text>
            <div v-if="!isCollection && !isGroup">
           <web-location-present-single :location="artefact.location"></web-location-present-single>
            </div>
            <div v-else-if="isCollection && !isGroup">
              <web-location-present-multiple :groupTitle="artefact" :heightM="mapHeight"></web-location-present-multiple>
            </div>
            <div v-else>
            <web-location-present-multiple-groups :groupTitle="artefact.title"></web-location-present-multiple-groups>
            </div>
            </v-card-text>
        </v-card>
      </v-tabs-content>
    </v-tabs-items>
  
  </v-tabs>

</template>

<script>
export default {
  data()
  {
    return{
     mapHeight:300,
    }
  },
  props:['artefact','isCollection','light','isGroup'],
}
</script>







// WEBPACK FOOTER //
// src/components/Partials/ArtefactSingleTab.vue